import PassportIdInfoCard from '../components/PassportIdInfoCard';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { passportInfos } from '../api';
import { AuthContext } from '../context/AuthContext';
import { ISalesIndividualPassport } from '../utils/types';
import { CircularProgress, Box } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

type PassportContainerProps = {
  salesIndividualId: string;
  lastName: string;
  orderNumber: string;
};

export function PassportContainer({
  salesIndividualId,
  lastName,
  orderNumber,
}: PassportContainerProps) {
  const [result, setResult] = useState<ISalesIndividualPassport[]>([]);
  const { token } = useContext(AuthContext);
  const { t } = useTranslation();
  const [, setError] = useState<string>();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchPassportInfos(salesIndividualId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesIndividualId]);

  const fetchPassportInfos = async (id: string) => {
    try {
      const res = await passportInfos(id, token);
      const data = await res.json();
      if (res?.status === 200) {
        setResult(data);
      } else {
        throw data;
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      setError(e.detail || t('loginPage.registerErrorMessage'));
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <CircularProgress color="secondary" />;
  }

  if (result.length) {
    return (
      <Grid2 container spacing={4}>
        {result?.map((r: ISalesIndividualPassport, i: number) => (
          <Grid2 xs={12} md={6} lg={4} key={i}>
            <PassportIdInfoCard
              key={`passport-${r.itemId}-${i}`}
              passportInfo={r}
            />
          </Grid2>
        ))}
      </Grid2>
    );
  }
  return (
    <Box
      sx={{
        mt: 2,
        mb: 4,
      }}
    >
      {t('passportIdInfoCard.noRecord')}{' '}
      <span style={{ textDecoration: 'underline' }}>
        {t('accountContainer.noRecordWord')}
      </span>
    </Box>
  );
}
